import {Button, Popover, PopoverContent, PopoverTrigger, useDisclosure} from "@heroui/react";
import _ from 'lodash';
import {useAudioPlayer} from 'react-use-audio-player';
import {useEffect, useMemo, useState} from 'react';
import {useUpdateFormValue} from '../helpers/AppHelper.jsx';
import {useRecoilState} from 'recoil';
import {speakersState} from '../store.jsx';
import toast from 'react-hot-toast';
import Voices from '../components/textToSpeech/Voices.jsx';

export default function VoiceSettingsItem({language = "English", index = 0, selectedSpeaker = null, form, data, onChange, title = "Speaker name"}) {
	const {isOpen, onOpen, onOpenChange} = useDisclosure();
	const updateValue = useUpdateFormValue(onChange)
	const {load, togglePlayPause, isLoading, isReady, playing, stop} = useAudioPlayer()

	const [selectedVoice, setSelectedVoice] = useState('')

	const [speakers] = useRecoilState(speakersState)

	const onPlayAudio = (audio) => {
		if (!_.startsWith(audio, 'http')) {
			toast.error('audio file not found!')
			return;
		}
		load(audio,{
			autoplay: true
		})
	}

	useEffect(() => {
		const speaker = checkAndSelectSpeaker(selectedSpeaker, speakers)
		setSelectedVoice(speaker?.voice_id || _.head(speakers)?.voice_id)
	}, [speakers]);

	useEffect(() => {
		const speaker = checkAndSelectSpeaker(selectedVoice || selectedSpeaker, speakers)
		if (!_.isEmpty(speaker)) {
			updateValue(`speakers.${index}.voice_id`, speaker?.voice_id)
		}
	}, [selectedVoice]);

	const selectedSpeakerOb = useMemo(() => {
		stop()
		return _.find(speakers || [], (item) => item?.voice_id == selectedVoice);
	}, [selectedVoice])

	const checkAndSelectSpeaker = (speakerID) => {
		return _.find(speakers || [], (item) => item?.voice_id == speakerID);
	}

	useEffect(() => {
		const speaker = checkAndSelectSpeaker(selectedSpeaker, speakers)
		setSelectedVoice(speaker?.voice_id)
	}, [index, speakers]);


	return (
		<>
			<Popover
				shouldFlip={true}
				offset={10}
				classNames={{
					content: "p-3 pb-6 max-h-[80vh] overflow-y-auto"
				}}
				showArrow
				isOpen={isOpen}
				onOpenChange={onOpenChange}
				shouldBlockScroll={false}
				shouldCloseOnScroll={false}
				placement="bottom"
				backdrop="opaque">
				<PopoverTrigger>
					<Button onPress={onOpen} variant="flat" isIconOnly color="" fullWidth
									className="bg-default-50 border-divider">
						<i className="hgi-stroke hgi-preference-horizontal text-xl font-bold"></i>
					</Button>
				</PopoverTrigger>
				<PopoverContent>
					<div className="w-full flex justify-between items-center mb-2 border-b border-default-100 pb-1">
						<h3 className="text-left w-full font-sans">{title}</h3>
						<Button
							onPress={onOpenChange} variant="light"
							isIconOnly color="danger" fullWidth>
							<i className="hgi-stroke hgi-cancel-01 font-bold text-lg"></i>
						</Button>
					</div>
					<div className="text-left w-full mb-2 mt-3">
						<p>Voice</p>
					</div>
					<div className="flex w-full min-w-72 items-end gap-1">
						<Voices
							classNames={{
								trigger: 'border-slate-500',
							}}
							data={speakers || []}
							onChange={(key, value) => setSelectedVoice(value)}
							value={selectedVoice}
							textValueKey="speaker_name"
							voiceKey="speaker_voice"
							valueKey="voice_id"
						/>
					</div>
				</PopoverContent>
			</Popover>
		</>
	);
}